import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';
@Injectable({
  providedIn: 'root'
})
export class StripeService {
    private http = inject(HttpClient);
    private BASE_URL = environment.apiUrl + 'api';

    resiliateSubscription(userId: string, subscriptionId: string): Observable<any> {
        return this.http.post(`${this.BASE_URL}/stripe/cancel`, { user_id: userId, plan_id: subscriptionId });
    }
}
